import {
    Button,
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
    Input,
    Label,
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue,
    cn,
} from '@repo/shadcn';

import { PLoader } from '@components/ui/loader/pill-loader';

import { formatCurrencyInBDT } from '@/utils/currency-formater';
import { formatDate } from '@/utils/date-formater';

import {
    PaymentProvider,
    usePurchasePayment,
} from './purchase-payment.provider';

const MakePurchasePayment = () => {
    return (
        <PaymentProvider>
            <DuePurchasePayment />
        </PaymentProvider>
    );
};

function DuePurchasePayment() {
    const {
        suppliers,
        purchasePayments,
        selectedCustomer,
        selectedDues,
        handleDueSelection,
        handleCustomerChange,
        handlePaymentAmountChange,
        dueLoading,
        handleSubmit,
        totalAmount,
        multiOrderLoading,
    } = usePurchasePayment();

    return (
        <Card className="mx-auto w-full max-w-2xl border-none shadow-none">
            <CardHeader>
                <CardTitle>Due Purchase Payment</CardTitle>
                <CardDescription>
                    Select Supplier and dues to pay
                </CardDescription>
            </CardHeader>
            <CardContent>
                <form>
                    <div className="space-y-4">
                        <div className="space-y-2">
                            <Label htmlFor="customer">Select Supplier</Label>
                            <Select
                                onValueChange={handleCustomerChange}
                                value={selectedCustomer}
                            >
                                <SelectTrigger>
                                    <SelectValue placeholder="Select a supplier" />
                                </SelectTrigger>
                                <SelectContent>
                                    {suppliers?.data?.map((supplier) => (
                                        <SelectItem
                                            key={supplier.id}
                                            value={supplier.id}
                                        >
                                            {supplier.name}
                                        </SelectItem>
                                    ))}
                                </SelectContent>
                            </Select>
                        </div>

                        <Card className="space-y-3 border-none">
                            {dueLoading ? (
                                <PLoader />
                            ) : (
                                purchasePayments?.data?.map((due) => {
                                    const isSelected = selectedDues?.includes(
                                        due.id,
                                    );
                                    return (
                                        <Card
                                            key={due.id}
                                            className={cn(
                                                'cursor-pointer bg-white shadow-none',
                                                isSelected
                                                    ? 'border-2 border-green-700 border-primary bg-green-50'
                                                    : 'hover:border-primary/50 border-[1px] border-red-500',
                                            )}
                                            onClick={() =>
                                                handleDueSelection(
                                                    due.id,
                                                    due.payment?.total_price ??
                                                        0 -
                                                            (due.payment
                                                                ?.total_paid ??
                                                                0),
                                                )
                                            }
                                        >
                                            <CardContent className="flex items-center justify-between p-4">
                                                <div className="grid gap-1">
                                                    <h3 className="font-semibold">
                                                        {formatDate(
                                                            due.created_at,
                                                        )}
                                                    </h3>
                                                    <div className="flex gap-5">
                                                        <span className="text-sm font-semibold text-yellow-800">
                                                            Total:
                                                            {formatCurrencyInBDT(
                                                                due.payment
                                                                    ?.total_price,
                                                            )}
                                                        </span>
                                                        <span className="text-sm font-semibold text-green-500">
                                                            Paid:
                                                            {formatCurrencyInBDT(
                                                                due.payment
                                                                    ?.total_paid ??
                                                                    0,
                                                            )}
                                                        </span>
                                                        <span className="text-sm font-semibold text-red-500">
                                                            Due:
                                                            {formatCurrencyInBDT(
                                                                (due.payment
                                                                    ?.total_price ??
                                                                    0) -
                                                                    (due.payment
                                                                        ?.total_paid ??
                                                                        0),
                                                            )}
                                                        </span>
                                                    </div>
                                                </div>
                                                {isSelected && (
                                                    <div className="flex items-center gap-2">
                                                        <span className="text-sm text-muted-foreground">
                                                            Pay:
                                                        </span>
                                                        <Input
                                                            type="number"
                                                            min="0"
                                                            step="0.01"
                                                            defaultValue={formatCurrencyInBDT(
                                                                due.payment
                                                                    ?.total_price,
                                                            )}
                                                            onChange={(e) =>
                                                                handlePaymentAmountChange(
                                                                    due.id,
                                                                    e.target
                                                                        .value,
                                                                )
                                                            }
                                                            className="h-8 w-24"
                                                            onClick={(e) =>
                                                                e.stopPropagation()
                                                            }
                                                        />
                                                    </div>
                                                )}
                                            </CardContent>
                                        </Card>
                                    );
                                })
                            )}
                            {purchasePayments?.data?.length &&
                                purchasePayments?.data?.length < 1 && (
                                    <p className="py-4 text-center">
                                        No due found!
                                    </p>
                                )}
                        </Card>
                        {
                            <Card>
                                <CardContent className="pt-6">
                                    {/* <div className="flex items-center justify-between">
                    <div className="text-sm font-medium">Current Paid:</div>
                    <div className="text-lg font-semibold">
                      {formatCurrencyInBTD(paymentAmounts.amount)}
                    </div>
                  </div> */}
                                    <div className="flex items-center justify-between">
                                        <div className="text-sm font-medium">
                                            Current Due:
                                        </div>
                                        <div className="text-lg font-semibold">
                                            {formatCurrencyInBDT(totalAmount)}
                                        </div>
                                    </div>
                                </CardContent>
                                <CardFooter className="flex justify-end">
                                    <Button
                                        type="button"
                                        onClick={handleSubmit}
                                    >
                                        {multiOrderLoading
                                            ? 'Loading...'
                                            : 'Submit Payment'}
                                    </Button>
                                </CardFooter>
                            </Card>
                        }
                    </div>
                </form>
            </CardContent>
        </Card>
    );
}

export default MakePurchasePayment;
